const PanelDetailsCaraousalSkeleton = [
    { span: 5, height: "24px" },
    {
        classes: "marginTop-16",
        height: "92px",
        columns: [
            {
                span: 1,
                height: "92px",
                rows: [{ span: 1, height: "92px" }],
            },
            {
                span: 3,
                height: "92px",
                rows: [
                    { span: 3, height: "20px" },
                    { span: 3, height: "20px", classes: "marginTop-4" },
                    { span: 2, height: "15px", classes: "marginTop-8" },
                    { span: 2, height: "15px", classes: "marginTop-4" },
                ],
            },
            {
                span: 1,
                height: "92px",
                rows: [{ span: 1, height: "92px" }],
            },
            {
                span: 3,
                height: "92px",
                rows: [
                    { span: 3, height: "20px" },
                    { span: 3, height: "20px", classes: "marginTop-4" },
                    { span: 2, height: "15px", classes: "marginTop-8" },
                    { span: 2, height: "15px", classes: "marginTop-4" },
                ],
            },
            {
                span: 1,
                height: "92px",
                rows: [{ span: 1, height: "92px" }],
            },
            {
                span: 3,
                height: "92px",
                rows: [
                    { span: 3, height: "20px" },
                    { span: 3, height: "20px", classes: "marginTop-4" },
                    { span: 2, height: "15px", classes: "marginTop-8" },
                    { span: 2, height: "15px", classes: "marginTop-4" },
                ],
            },
        ],
    },
]

export default PanelDetailsCaraousalSkeleton
